import React, { createContext, useReducer } from "react";
import ShopReducer from "../reducers/shop.reducer";
import { BuildingInput } from "src/types/buildings-input";

const initialState: any = {
  buildings: [
    new BuildingInput(),
  ],
  hasError: true,
};

export const ShopContext = createContext(initialState);
export const ShopProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(ShopReducer, initialState);

  function buildingsCountChange(type: string) {
    dispatch({
      type: "BUILDINGS_COUNT_CHANGE",
      payload: { type }
    });
  }

  function inputChange(index: number, prop: string, value: string) {
    dispatch({
      type: "INPUT_CHANGE",
      payload: { index, prop, value }
    });
  }

  return (
    <ShopContext.Provider
      value={{
        ...state,
        inputChange,
        buildingsCountChange
      }}
    >
      { children }
    </ShopContext.Provider>
  );
};